var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveNakshatraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 0H4C1.79086 0 0 1.79086 0 4V29C0 31.2091 1.79086 33 4 33H29C31.2091 33 33 31.2091 33 29V4C33 1.79086 31.2091 0 29 0Z",
    fill: "url(#paint0_linear_104_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7C18.95 7 17.91 7.27 17 7.81C16.64 8 16.3 8.26 16 8.54C15.7 8.26 15.36 8 15 7.81C14.09 7.27 13.05 7 12 7C10.4087 7 8.88258 7.63214 7.75736 8.75736C6.63214 9.88258 6 11.4087 6 13C6 14.5913 6.63214 16.1174 7.75736 17.2426C8.88258 18.3679 10.4087 19 12 19V17C10.9391 17 9.92172 16.5786 9.17157 15.8284C8.42143 15.0783 8 14.0609 8 13C8 11.9391 8.42143 10.9217 9.17157 10.1716C9.92172 9.42143 10.9391 9 12 9C12.5676 9.00263 13.1283 9.12514 13.6453 9.35951C14.1623 9.59388 14.6239 9.93482 15 10.36V27H17V10.36C17.08 10.27 17.16 10.18 17.25 10.1C17.6313 9.73777 18.0802 9.45428 18.5711 9.26574C19.0621 9.07721 19.5854 8.98734 20.1111 9.00127C20.6368 9.0152 21.1546 9.13267 21.6349 9.34694C22.1152 9.56121 22.5485 9.86808 22.91 10.25C23.6392 11.0192 24.0331 12.0465 24.005 13.1061C23.9768 14.1656 23.529 15.1706 22.76 15.9C22 16.61 21.03 17 20 17V19C21.5913 19 23.1174 18.3679 24.2426 17.2426C25.3679 16.1174 26 14.5913 26 13C26 11.4087 25.3679 9.88258 24.2426 8.75736C23.1174 7.63214 21.5913 7 20 7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_104_9",
    x1: 33,
    y1: 16.5,
    x2: 0,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CFBD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#37B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#776FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F071FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNakshatraIcon);
export default __webpack_public_path__ + "static/media/activeNakshatraIcon.73ef4d298fb57f7ddfac895843623f84.svg";
export { ForwardRef as ReactComponent };